<template>
  <header
    class="flex h-14 flex-shrink-0 items-center justify-between border-b py-2 pe-2 ps-4 surface-panel-blur brd-highlight"
  >
    <h1 class="page-title flex flex-nowrap items-center gap-2">
      {{ headerTitle }}
    </h1>

    <div class="flex items-center gap-2">
      <woot-input
        v-if="hasSearch"
        icon="search"
        :value="searchQuery"
        :placeholder="$t('CHATLYN_MESSAGE_TEMPLATE.SEARCH_QUERY_PLACEHOLDER')"
        @input="handleSearchQueryChange"
      />

      <woot-button
        v-if="!hideCreateButton"
        v-tooltip="disabledTooltipProps"
        :disabled="isCreateDisabled"
        color-scheme="success"
        icon="add-circle"
        data-testid="create-new-message-template"
        @click="$emit('create-template')"
      >
        {{ createButtonText }}
      </woot-button>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import { MESSAGE_TEMPLATES_CHANNEL_TYPE } from '../constants';

export default {
  name: 'MessageTemplatesHeader',
  props: {
    headerTitle: {
      type: String,
      default: '',
    },

    hasSearch: {
      type: Boolean,
      default: false,
    },

    searchQuery: {
      type: String,
      default: '',
    },

    hideCreateButton: {
      type: Boolean,
      default: false,
    },

    icon: {
      type: String,
      default: '',
    },

    messageTemplateType: {
      type: String,
      default: MESSAGE_TEMPLATES_CHANNEL_TYPE.WHATSAPP,
    },
  },

  computed: {
    ...mapGetters({
      managementSms: 'management/getSms',
      isPhoenix: 'accounts/isPhoenix',
    }),
    createButtonText() {
      return this.$t(
        `CHATLYN_MESSAGE_TEMPLATE.BUTTON.NEW_TEMPLATE.${this.messageTemplateType.toUpperCase()}`
      );
    },
    isCreateDisabled() {
      // Enable create button if it's Phoenix
      if (this.isPhoenix) {
        return false;
      }
      const isSMS =
        this.messageTemplateType === MESSAGE_TEMPLATES_CHANNEL_TYPE.SMS;
      const disabledSMS =
        !this.managementSms?.enabled || !this.managementSms?.shortNames?.length;
      return isSMS && disabledSMS;
    },
    disabledTooltipProps() {
      const delayDuration = 300;
      return {
        content: this.$t(
          'CHATLYN_MESSAGE_TEMPLATE.BUTTON.NEW_TEMPLATE.DISABLED_TOOLTIP'
        ),
        classes: this.isCreateDisabled ? ['w-52'] : ['hidden'],
        delay: { show: delayDuration, hide: delayDuration },
        offset: '4',
      };
    },
  },

  methods: {
    onToggleDeleteSegmentsModal() {
      this.$emit('on-toggle-delete-filter');
    },

    onToggleSendMessage() {
      this.$emit('on-toggle-send-message');
    },

    handleSearchQueryChange(newValue) {
      this.$emit('change-search-query', newValue);
    },
  },
};
</script>
